
export enum webService_ObjectTypeEnum {
    Import_AED_Alert = 1, 
    Import_AG5 = 2,
    Export_2WAY = 3,
    Export_Alarm_Reporting = 4,
    Export_Occupancy_Reporting = 5,
    Export_Occupancy_Reportingv2 = 6,
    Incomming_GMS_Incident_aansluiting = 7,
    Outgoing_GMS_Incident_aansluiting_V5 = 8,
    Outgoing_WordPress_narrowcast = 9,
    Outgoing_2Way_Acknowledge_message = 10,
    Outgoing_2Way_Acknowledge_attendance = 11,
    Outgoing_2Way_Report_location = 12,
    Outgoing_GMS_VerbindingStatusRequest_V5 = 13,
    Outgoing_GMS_IncidentSynchronisatieRequest_V5 = 14,
    Outgoing_GMS_Incident_aansluiting_V6 = 15,
    Outgoing_GMS_VerbindingStatusRequest_V6 = 16,
    Outgoing_GMS_IncidentSynchronisatieRequest_V6 = 17,
    Outgoing_GMS_Incident_aansluiting_V7 = 18,
    Outgoing_GMS_VerbindingStatusRequest_V7 = 19,
    Outgoing_GMS_IncidentSynchronisatieRequest_V7 = 20,
    Outgoing_GMS_Incident_aansluiting_V8 = 21,
    Outgoing_GMS_VerbindingStatusRequest_V8 = 22,
    Outgoing_GMS_IncidentSynchronisatieRequest_V8 = 23
}
